import { GetUsersMe200Response } from '@src/api/generated/user-api'
import { L_STORAGE_KEYS, STORY_BOOK } from '@src/consts'
import { lStorage } from '@src/utils/'

export const setLocalStorage = ({
  id = STORY_BOOK.USER_ID,
  hasCardContract = true,
  hasPayContract = true,
  isGeneralUser = false,
  isOrganizationAdmin = false,
  isBookkeeper = false,
  isViewer = false,
  isTempPassword = false,
  organizationId = STORY_BOOK.ORGANIZATION_ID,
  name = STORY_BOOK.USER_NAME,
  freeeCompanyId = STORY_BOOK.FREEE_COMPANY_ID,
  availableFeatures = [],
  contracts = [],
}: Partial<GetUsersMe200Response>) => {
  lStorage.setItem({
    key: L_STORAGE_KEYS.USER,
    value: {
      freeeCompanyId,
      hasCardContract,
      hasPayContract,
      id,
      isBookkeeper,
      isGeneralUser,
      isOrganizationAdmin,
      isTempPassword,
      isViewer,
      organizationId,
      userName: name,
      availableFeatures,
      contracts,
    },
  })
}
